import { renderSettingsMCQ } from "../MCQ";

const renderSettingsV2FillBlank = renderSettingsMCQ;

export default renderSettingsV2FillBlank;
